import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import VpcBaseIndex from "..//base/vpc/index.vue";
import apiRequest from '../../service/vpc/request';
import trustApiRequest from '../../service/trust_vpc/request';
import { Form, FormItem } from "kpc/components/form";
import { Button, ButtonGroup } from 'kpc/components/button';
import { Table, TableColumn } from 'kpc/components/table';
import Icon from 'kpc/components/icon';
import Input from 'kpc/components/input';
import { Select, Option } from 'kpc/components/select';
import { Tabs, Tab } from 'kpc/components/tabs';
import Tip from 'kpc/components/tip';
import Tooltip from "kpc/components/tooltip";
import Message from 'kpc/components/message';
import Spinner from 'kpc/components/spinner';
import vpcData from "../../service/vpc/vpcData";
import CopyIcon from '../../components/CopyIcon/index.vue';
import KpcViewTitle from "../../components/KpcViewTitle/index.vue";
import TableColumnEdit from "../../components/TableColumnEdit/index.vue";
import validator from "../../service/common/validator";
import getDhcp from "../validator/getDhcp";
import rulesCheck from "../validator/sgRulesCheck";
import whiteList from "../../service/common/whiteList";
import commonApiRequest from "../../service/common/apiRequest";
import getRegionChina from "../../service/common/getRegionChinaFunc";

import GroupRuleTable from "../../components/GroupRuleTable/index.vue";
import GroupRuleTableType from '../../components/GroupRuleTable/_vue';

import * as _ from 'lodash';
import Pagination from 'kpc/components/pagination';
import { debounce } from "helpful-decorators";

const getTabName = (route: any): string => {
    if (route.name === 'groupCreate' || route.name === 'trustGroupCreate') {
        return route.params.type;
    }
    return route.name.replace(route.name.indexOf('trust') !== -1 ? 'trustGroupCreate' : 'groupCreate', '');
}
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate',
]);

@Component({
    components: {
        Table,
        TableColumn,
        KpcViewTitle,
        TableColumnEdit,
        Pagination,
        Input,
        Form, FormItem,
        Select, Option,
        CopyIcon,
        Button, ButtonGroup,
        Icon,
        Spinner,
        Tabs, Tab,
        Tip,
        Tooltip,
        GroupRuleTable
    },
    mixins: [VpcBaseIndex],
    // beforeRouteEnter(to, from, next) {
    //     next((vm: any) => {
    //         vm.tab = getTabName(to);
    //     })
    // },
    // beforeRouteUpdate(to, from, next) {
    //     let me: any = this;
    //     me.tab = getTabName(to);
    //     next();
    // }
})
export default class GroupCreateView extends Vue {
    tab = '';
    inNotValid: boolean = true;
    outNotValid: boolean = true;
    isSameRuleIn: boolean = false;
    isSameRuleOut: boolean = false;
    isNameTrue: boolean = false;
    createRules: any = {
        in: [],
        out: []
    };
    regionList: any[] = [];
    regionListCurrent: any = {
        title: '',
        value: ''
    };
    arrParamInNew: any[] = [];
    arrParamOutNew: any[] = [];
    ipVersion = 'ipv4';
    originPage = 'create';
    newGroupName: any = '';
    isNameError: boolean = false;
    currentVpcs: any = {
        title: '',
        value: '',
        cidrBlock: '',
        ipv6: null
    };
    createVpcList: any[] = [];
    expandedInRuleKeys: any[] = [];
    expandedOutRuleKeys: any[] = [];
    listOfChecked: any[] = [];
    region: any = '';
    protocolList: any[] = [
        { title: 'IP', value: 'ip' },
        { title: 'ICMP', value: 'icmp' },
        { title: 'TCP', value: 'tcp' },
        { title: 'UDP', value: 'udp' },
        { title: 'ICMP ping', value: 'ping' },
        { title: 'TCP ssh(22)', value: 'ssh' },
        { title: 'TCP http(80)', value: 'http' },
        { title: 'TCP https(443)', value: 'https' },
        { title: 'UDP openvpn(1194)', value: 'openvpn' },
        { title: this.$trans(`TCP Windows远程登录`), value: 'remote' }
    ];
    IcmpTypeList: any[] = [
        { title: this.$trans(`全部协议`), value: '-1' },        
        { title: 'Echo', value: '8' },
        { title: 'Echo Reply', value: '0' },
        { title: 'Destination Unreachable', value: '3' },
        { title: 'Source Quench', value: '4' },
        { title: 'Redirect Message', value: '5' },
        { title: 'Router Advertisement', value: '9' },
        { title: 'Router Solicitation', value: '10' },
        { title: 'Time Exceeded', value: '11' },
        { title: 'Parameter Problem: Bad IP header', value: '12' },
        { title: 'Timestamp', value: '13' },
        { title: 'Timestamp Reply', value: '14' },
        { title: 'Information Request', value: '15' },
        { title: 'Information Reply', value: '16' },
        { title: 'Address Mask Reques', value: '17' },
        { title: 'Address Mask Reply', value: '18' },
        { title: 'Traceroute', value: '30' },
    ];
    inRuleId: number = 0;
    outRuleId: number = 0;
    icmpTypes: any[] = [];
    sgDirect = '';
    ruleList: any[] = [];
    timer = {
        timerPay: null
    };
    isLoading: boolean = false;
    reverse: any = '';

    vpcId = '';
    subnetId = '';
    groupId = '';
    detail: any = {};
    interfaceEpcCount = 0;
    sgSupportEpcDeny = false;
    newInRulesData: any[] = [];
    newOutRulesData: any[] = [];
    secGroupType: string = 'other';

    get regionSupportDeny() {
        let me: any = this;
        return whiteList.check("sgSupportDeny", me.region);
    }

    get request() {
        return this.isTrustVpc ? trustApiRequest : apiRequest
    }

    get backRoute() {
        return this.isTrustVpc ? "trustGroup" : "group"
    }

    get isGlobalGroup() {
        return this.secGroupType === 'global';
    }

    getSgSupportEpcDeny() {
        let me: any = this;
        // 安全组deny规则是否支持epc。1、不支持；2、支持
        commonApiRequest.DescribeQuotaByName({
            Region: me.region,
            QuotaName: 'quota_vpc_securitygroupepcdeny'
        }).done((data: any) => {
            if (data && data.QuotaMax) {
                this.sgSupportEpcDeny = data.QuotaMax == 2 ? true : false;
            }
        });
    }

    @Watch("regionListCurrent.value", {
        deep: true
    })
    RegionListCurrentValueWatcher(val: any, oldVal: any) {
        let me: any = this;
        if (val) {
            me.region = val;
            me.getFromVpcs(val);
        }
    }

    public beforeRouteEnter(to: any, from: any, next: any) {
        next((vm: any) => {
            vm.tab = getTabName(to);
        })
    }

    public beforeRouteUpdate(to: any, from: any, next: any) {
        let me: any = this;
        me.tab = getTabName(to);
        next();
    }

    @Watch("currentVpcs.value", {
        deep: true
    })
    CurrentVpcsValueWatcher(val: any, oldVal: any) {
        let me: any = this;
        if (this.secGroupType === 'global') {
            me.ipVersion = 'ipv4';
            me.currVpcSupportIpv6 = false;
        } else {
            if (!val) { return; }
            const currVpc = _.find(me.vpcList, ["VpcId", val]);
            if (currVpc && currVpc.Ipv6CidrBlockAssociationSet && currVpc.Ipv6CidrBlockAssociationSet.length > 0) {
                me.ipVersion = 'ipv6';
                me.currVpcSupportIpv6 = true;
            } else {
                me.ipVersion = 'ipv4';
                me.currVpcSupportIpv6 = false;
            }
            me.$refs.GroupInRuleTable.rules = [];
            me.$refs.GroupOutRuleTable.rules = [];
    
            me.getSubReverse();
        }
        me.initRuleTableData();
    }

    @Watch("secGroupType")
    secGroupTypeWatcher(val: any) {
        const me: any = this;

        if (val === 'global') {
            this.ipVersion = 'ipv4';
        } else {
            const currVpc = _.find(me.vpcList, ["VpcId", me.currentVpcs.value]);
            if (currVpc && currVpc.Ipv6CidrBlockAssociationSet && currVpc.Ipv6CidrBlockAssociationSet.length > 0) {
                me.ipVersion = 'ipv6';
                me.currVpcSupportIpv6 = true;
            } else {
                me.ipVersion = 'ipv4';
                me.currVpcSupportIpv6 = false;
            }
        }
        me.$refs.GroupInRuleTable.rules = [];
        me.$refs.GroupOutRuleTable.rules = [];

        me.initRuleTableData();
    }

    @Watch("createRules.in", {
        deep: true
    })
    CreateRulesInWatcher(val: any, oldVal: any) {
        let me: any = this;
        //如果找不到icmpCode 那么设置0 永远是选中第一个icmpCode
        _.forEach(me.createRules.in, (item) => {
            var code = me.getIcmpCode(item.IcmpCode, item.IcmpType)
            if (!code) {
                item.IcmpCode = 0;
            }
        })
    }

    @Watch("createRules.out", {
        deep: true
    })
    CreateRulesOutWatcher(val: any, oldVal: any) {
        let me: any = this;
        //如果找不到icmpCode 那么设置0 永远是选中第一个icmpCode
        _.forEach(me.createRules.out, (item) => {
            var code = me.getIcmpCode(item.IcmpCode, item.IcmpType)
            if (!code) {
                item.IcmpCode = 0;
            }
        })
    }

    @Watch("newGroupName", {
        deep: true
    })
    NewGroupNameWatcher(val: any, oldVal: any) {
        let me: any = this;
        if (me.newGroupName) {
            me.isNameError = !validator.commonName(_.trim(me.newGroupName), 64)
        } else {
            me.isNameError = false
        }
    }

    created() {
        let me: any = this;
    }

    refreshVpcList() {
        this.getFromVpcs(this.region);
    }

    getIcmpCode(code: any, type: any) {
        let me: any = this;
        if (code == '-1') {
            code = 0;
        }
        let text;
        _.forEach(me.icmpTypes[type], (item) => {
            if (item.value == code) {
                text = item.text
            }
        })
        return text;
    }

    @debounce(200)
    async getList() {
        let me: any = this;
        me.region = this.$route.params.region;
        me.icmpTypes = vpcData.icmpTypes;
        me.vpcId = me.$route.params.vpcId;
        me.reverse = me.$route.params.reverse;
        me.getRegion(me.region);
        me.getFromVpcs(me.region);
        me.getSgSupportEpcDeny();
        
        // me.initRuleTableData();
    }

    @debounce(500)
    initRuleTableData() {
        let me: any = this;
        // PM要求默认自动生成5条入站规则、1条出站规则；
        const protocol = ['http', 'https', 'ssh', 'remote', 'icmp'];
        for (let i = 0; i < protocol.length; i++) {
            me.$refs.GroupInRuleTable.addRuleItem("init", protocol[i], me.ipVersion);
        }
        me.$refs.GroupOutRuleTable.addRuleItem("init", "ip", me.ipVersion);
    }

    createRuleItem(sgDirect: any) {
        let me: any = this;
        let itemData: any = {
            Description: '',
            Policy: 'Accept',
            Priority: 1,
            RuleName: '',
            CidrBlock: '0.0.0.0/0',
            Range: '0',
            RuleAction: 'allow',
            RuleTag: '',
            Protocol: 'tcp',
            IcmpType: '-1',
            IcmpCode: 0,
            PortRangeFrom: '',
            PortRangeTo: '',
            isError: false,
            errorMsg: '',

        };

        if (sgDirect === 'out') {
            itemData.RuleId = 'out_' + me.outRuleId++;
            itemData.Direction = 'out';
            me.createRules.out.push(itemData);
        } else {
            itemData.RuleId = 'in_' + me.inRuleId++;
            itemData.Direction = 'in';
            me.createRules.in.push(itemData);
        }
    }

    removeRuleItem(row: any, index: any, sgDirect: any) {
        let me: any = this;
        if (sgDirect === 'out') {
            me.createRules.out.splice(index, 1);
        } else {
            me.createRules.in.splice(index, 1);
        }

    }

    //获取对端vpc列表
    getFromVpcs(region: any) {
        let me: any = this;
        this.tab = "inRule";
        return new Promise((resolve, reject) => {
            //获取所有的VPC
            // apiRequest.DescribeVpcs({
            this.request.DescribeVpcs({
                Region: region
            }).done(function (data: any) {
                var arr: any = [];
                _.forEach(data.vpcSet, function (item) {
                    let title = `${item.VpcName}(${(item.CidrBlock)})`
                    let ipv6 = _.get(item, 'Ipv6CidrBlockAssociationSet[0].Ipv6CidrBlock')
                    if (ipv6) {
                        title = `${item.VpcName}(${item.CidrBlock}, ${ipv6})`
                    }
                    arr.push({
                        title,
                        value: item.VpcId,
                        cidrBlock: item.CidrBlock,
                        ipv6: ipv6
                    })
                })
                if (!arr.length) {
                    return;
                }
                me.createVpcList = arr;
                if (localStorage.vpcId === 'all') {
                    me.currentVpcs = arr[0];
                } else {
                    let crrVpc = _.find(arr, (item) => {
                        return item.value === localStorage.vpcId;
                    }) || {};
                    me.currentVpcs = crrVpc;
                }

                me.getSubReverse();
                // me.vpcChangeSelect();
                resolve(data)
            })
        })
    }

    getRegion(region: any) {
        var me = this;
        var regionList = me.allRegions;
        var vpcRegionList: any[] = [];
        _.forEach(regionList, (v) => {
            if (v.isVpc != 1) {
                return;
            }
            vpcRegionList.push({
                title: this.$trans(getRegionChina(v.code)) || v.name,
                value: v.code
            });
        });
        me.regionList = vpcRegionList;
        var item = _.find(me.regionList, ['value', region]);
        if (item) {
            me.regionListCurrent = item;
        }
    }

    //获取终端子网 TCP健康检查时候用到
    getSubReverse() {
        let me: any = this;
        me.reverse = '';
        if (!me.currentVpcs.value) {
            return;
        }
        // apiRequest.DescribeSubnets({
        this.request.DescribeSubnets({
            Region: me.region,
            'Filter.1.Name': 'vpc-id',
            'Filter.1.Value.1': me.currentVpcs.value
        }).done((data: any) => {
            let subnetListRe = data.SubnetSet || [];
            let arrReverse: any[] = [];
            _.forEach(subnetListRe, function (item) {
                if (item.SubnetType == "Reserve") {
                    arrReverse.push(item)
                }
            })
            if (arrReverse.length == 0) {
                me.reverse = ''
            } else {
                me.reverse = arrReverse[0].CidrBlock
            }
        })
    }

    formatRule(type: any) {
        let me: any = this;

        let cloneRulesData: any[] = [];
        if (type == 'in') {
            me.newInRulesData = [];
            cloneRulesData = me.$refs.GroupInRuleTable.rules;
        } else {
            me.newOutRulesData = [];
            cloneRulesData = me.$refs.GroupOutRuleTable.rules;
        }

        const data: any = _.cloneDeep(cloneRulesData);
        
        _.forEach(data, (item, index: any) => {
            if (item) {
                let splitData: any[] = [];
                let tempData: any = _.cloneDeep(item);
                tempData.CidrBlock = item.CidrBlocks.length ? item.CidrBlocks.join() : '';
                if (item.Protocol == "icmp") {
                    tempData.IcmpType = item.IcmpType == "-1" ? "-1" : item.IcmpType.split("-")[0];
                    tempData.IcmpCode = item.IcmpType == "-1" ? "-1" : item.IcmpType.split("-")[1];
                    splitData.push(tempData);
                } else if (item.Protocol == "tcp" || item.Protocol == "udp") {
                    _.forEach(item.ProtocolPort, subitem => {
                        let temp: any = _.cloneDeep(item);
                        const splitPort = _.toString(subitem).split("-");
                        temp.CidrBlock = item.CidrBlocks.length ? item.CidrBlocks.join() : '';
                        temp.PortRangeFrom = splitPort.length > 1 ? splitPort[0] : subitem;
                        temp.PortRangeTo = splitPort.length > 1 ? splitPort[1] : subitem;
                        splitData.push(temp);
                    });
                } else {
                    splitData.push(tempData);
                }
                if (type == 'in') {
                    me.newInRulesData = me.newInRulesData.concat(splitData);
                } else {
                    me.newOutRulesData = me.newOutRulesData.concat(splitData);
                }
                
                cloneRulesData[index].CidrBlock = item.CidrBlocks.length ? item.CidrBlocks.join() : '';
                if (!item.ProtocolPort.length) {
                    cloneRulesData[index].PortRangeFrom = "";
                    cloneRulesData[index].PortRangeTo = "";
                }
            }
        });

        //清空提示
        let arrNew: any[] = [];
        let ruleKeys: any[] = [];
        _.forEach(cloneRulesData, (item, index) => {
            item.PortRangeFrom = _.trim(item.PortRangeFrom)
            item.PortRangeTo = _.trim(item.PortRangeTo)
            item.CidrBlock = _.trim(item.CidrBlock)
            item.Description = _.trim(item.Description)
            item.RuleTag = _.trim(item.RuleTag);
            arrNew.push(item);
        });
        cloneRulesData = rulesCheck.sgRulesCheck(arrNew, me, getDhcp);
        
        var onOff = false;
        _.forEach(cloneRulesData, (item) => {
            if (item.isError) {
                onOff = true;
                ruleKeys.push(item.RuleId);
            }
        });

        if (type == 'in') {
            let GroupInRuleTable = (this.$refs.GroupInRuleTable as GroupRuleTableType);
            GroupInRuleTable.setRules(cloneRulesData);
        } else {
            let GroupOutRuleTable = (this.$refs.GroupOutRuleTable as GroupRuleTableType);
            GroupOutRuleTable.setRules(cloneRulesData);
        }

        if (type == 'in') {
            if (onOff) {
                me.inNotValid = true;
                return;
            } else {
                me.inNotValid = false;
            }
        } else {
            if (onOff) {
                me.outNotValid = true;
                return;
            } else {
                me.outNotValid = false;
            }
        }

        me.expandedRuleKeys = ruleKeys;


        let arrParam: any[] = [];
        _.forEach(me.newRulesData, (item, idx) => {
            if (item.Protocol == "ssh") {
                if (item.CidrBlock != "") {
                    var obj: any = {
                        CidrBlock: item.CidrBlock,
                        Policy: item.Policy,
                        Priority: item.Priority,
                        Direction: item.Direction,
                        Protocol: "tcp",
                        PortRangeFrom: 22,
                        PortRangeTo: 22,
                        RuleTag: item.RuleTag,
                        Description: item.Description ? item.Description : null
                    };
                    if (item.SecurityGroupEntryId) {
                        obj.SecurityGroupEntryId = item.SecurityGroupEntryId;
                    }
                    arrParam.push(obj);
                }
            }
            if (item.Protocol == "http") {
                if (item.CidrBlock != "") {
                    var obj: any = {
                        CidrBlock: item.CidrBlock,
                        Policy: item.Policy,
                        Priority: item.Priority,
                        Direction: item.Direction,
                        Protocol: "tcp",
                        PortRangeFrom: 80,
                        PortRangeTo: 80,
                        RuleTag: item.RuleTag,
                        Description: item.Description ? item.Description : null
                    };
                    if (item.SecurityGroupEntryId) {
                        obj.SecurityGroupEntryId = item.SecurityGroupEntryId;
                    }
                    arrParam.push(obj);
                }
            }
            if (item.Protocol == "https") {
                if (item.CidrBlock != "") {
                    var obj: any = {
                        CidrBlock: item.CidrBlock,
                        Policy: item.Policy,
                        Priority: item.Priority,
                        Direction: item.Direction,
                        Protocol: "tcp",
                        PortRangeFrom: 443,
                        PortRangeTo: 443,
                        RuleTag: item.RuleTag,
                        Description: item.Description ? item.Description : null
                    };
                    if (item.SecurityGroupEntryId) {
                        obj.SecurityGroupEntryId = item.SecurityGroupEntryId;
                    }
                    arrParam.push(obj);
                }
            }
            if (item.Protocol == "remote") {
                if (item.CidrBlock != "") {
                    var obj: any = {
                        CidrBlock: item.CidrBlock,
                        Policy: item.Policy,
                        Priority: item.Priority,
                        Direction: item.Direction,
                        Protocol: "tcp",
                        PortRangeFrom: 3389,
                        PortRangeTo: 3389,
                        RuleTag: item.RuleTag,
                        Description: item.Description ? item.Description : null
                    };
                    if (item.SecurityGroupEntryId) {
                        obj.SecurityGroupEntryId = item.SecurityGroupEntryId;
                    }
                    arrParam.push(obj);
                }
            }
            if (item.Protocol == "healthy") {
                if (me.reverse != "") {
                    var obj: any = {
                        CidrBlock: me.reverse,
                        Policy: item.Policy,
                        Priority: item.Priority,
                        Direction: item.Direction,
                        Protocol: "tcp",
                        PortRangeFrom: 1,
                        PortRangeTo: 65535,
                        RuleTag: item.RuleTag,
                        Description: item.Description ? item.Description : null
                    };
                    if (item.SecurityGroupEntryId) {
                        obj.SecurityGroupEntryId = item.SecurityGroupEntryId;
                    }
                    arrParam.push(obj);
                }
            }
            if (item.Protocol == "ping") {
                if (item.CidrBlock != "") {
                    var obj: any = {
                        CidrBlock: item.CidrBlock,
                        Policy: item.Policy,
                        Priority: item.Priority,
                        Direction: item.Direction,
                        Protocol: "icmp",
                        IcmpCode: 0,
                        IcmpType: 8,
                        RuleTag: item.RuleTag,
                        Description: item.Description ? item.Description : null
                    };
                    if (item.SecurityGroupEntryId) {
                        obj.SecurityGroupEntryId = item.SecurityGroupEntryId;
                    }
                    arrParam.push(obj);
                }
            }
            if (item.Protocol == "openvpn") {
                if (item.CidrBlock != "") {
                    var obj: any = {
                        CidrBlock: item.CidrBlock,
                        Policy: item.Policy,
                        Priority: item.Priority,
                        Direction: item.Direction,
                        Protocol: "udp",
                        PortRangeFrom: 1194,
                        PortRangeTo: 1194,
                        RuleTag: item.RuleTag,
                        Description: item.Description ? item.Description : null
                    };
                    if (item.SecurityGroupEntryId) {
                        obj.SecurityGroupEntryId = item.SecurityGroupEntryId;
                    }
                    arrParam.push(obj);
                }
            }

            if (item.Protocol == "ip") {
                if (item.CidrBlock != "") {
                    var obj: any = {
                        CidrBlock: item.CidrBlock,
                        Policy: item.Policy,
                        Priority: item.Priority,
                        Direction: item.Direction,
                        Protocol: item.Protocol,
                        RuleTag: item.RuleTag,
                        Description: item.Description ? item.Description : null
                    };
                    if (item.SecurityGroupEntryId) {
                        obj.SecurityGroupEntryId = item.SecurityGroupEntryId;
                    }
                    arrParam.push(obj);
                }
            }
            if (item.Protocol == "tcp" || item.Protocol == "udp") {
                if (
                    item.CidrBlock != "" &&
                    item.PortRangeFrom != "" &&
                    item.PortRangeTo != ""
                ) {
                    var obj: any = {
                        CidrBlock: item.CidrBlock,
                        Policy: item.Policy,
                        Priority: item.Priority,
                        Direction: item.Direction,
                        Protocol: item.Protocol,
                        PortRangeFrom: item.PortRangeFrom,
                        PortRangeTo: item.PortRangeTo,
                        RuleTag: item.RuleTag,
                        Description: item.Description ? item.Description : null
                    };
                    if (item.SecurityGroupEntryId) {
                        obj.SecurityGroupEntryId = item.SecurityGroupEntryId;
                    }
                    arrParam.push(obj);
                }
            }
            if (item.Protocol == "icmp") {
                if (item.CidrBlock != "") {
                    var obj: any = {
                        CidrBlock: item.CidrBlock,
                        Policy: item.Policy,
                        Priority: item.Priority,
                        Direction: item.Direction,
                        Protocol: item.Protocol,
                        IcmpCode: Number(item.IcmpCode),
                        IcmpType: Number(item.IcmpType),
                        RuleTag: item.RuleTag,
                        Description: item.Description ? item.Description : null
                    };
                    if (item.IcmpType == "-1") {
                        obj.IcmpType = "-1";
                        obj.IcmpCode = "-1";
                    }
                    if (item.SecurityGroupEntryId) {
                        obj.SecurityGroupEntryId = item.SecurityGroupEntryId;
                    }
                    arrParam.push(obj);
                }
            }
        });

        //判断规则是否完全一样 就不需要判断字段筛选出去
        var rulesCloneDeep = _.cloneDeep(arrParam);
        var isEqual: any[] = [];
        _.forEach(rulesCloneDeep, function (item, id) {
            delete item.Description;
            delete item.Index;
            delete item.RuleName;
            delete item.Range;
            delete item.SecurityGroupEntryId;
            delete item.RuleTag;
            if (item.IcmpType) {
                item.IcmpType = Number(item.IcmpType)
            }
            if (item.IcmpCode) {
                item.IcmpCode = Number(item.IcmpCode)
            }
            if (item.PortRangeFrom) {
                item.PortRangeFrom = item.PortRangeFrom.toString()
            }
            if (item.PortRangeTo) {
                item.PortRangeTo = item.PortRangeTo.toString()
            }

            isEqual.push(JSON.stringify(item));
        });

        var arrParamNew: any[] = [];
        const equalRuleResult = me.isEqualRule(isEqual);

        //判断重复规则的 只保留一条
        if (equalRuleResult.indexArr.length > 0) {
            var arr = _.cloneDeep(arrParam);

            //先把所有重复的索引的元素删掉
            _.forEach(arr, (item, index) => {
                if (!_.includes(equalRuleResult.indexArr, index)) {
                    arrParamNew.push(item);
                }
            })

            //[[0,1],[2,5,6]]
            _.forEach(equalRuleResult.arrAll, (item, index) => {
                var col = item[0];
                _.forEach(arrParam, (item, index) => {
                    if (index == col) {
                        arrParamNew.push(item);
                    }
                })
            })
        } else {
            arrParamNew = arrParam;
        }

        //  筛选 arrParams编辑过的才传给后端 
        var filterArrParams: any[] = [];
        _.forEach(arrParamNew, function (item) {
            if (item.SecurityGroupEntryId) {
                var originJson = _.find(cloneRulesData, ['SecurityGroupEntryId', item.SecurityGroupEntryId])
                var isSame = true;
                _.forEach(item, function (v, k) {
                    if (item[k] != originJson[k]) {
                        isSame = false;
                    }
                })
                if (!isSame) {
                    filterArrParams.push(item)
                }
            } else {
                filterArrParams.push(item)
            }
        })
        // me.filterArrParams = filterArrParams;


        if (type == 'in') {
            me.arrParamInNew = arrParamNew;
        } else {
            me.arrParamOutNew = arrParamNew;
        }

        let allRepeatedRulesIndex: any[] = [];
        let repeatedRulesWithDesc: any[] = [];
        let repeatedRulesNoDesc: any[] = [];
        // 如果有重复的规则，那么将重复的规则展示在前端页面让用户来筛选
        if (equalRuleResult.arrAll.length > 0) {
            const arrParamCloneDeep = _.cloneDeep(arrParam);
            equalRuleResult.arrAll.forEach((arrItem: any, arrIndex: any) => {
                const desc = arrParamCloneDeep[arrItem[0]].Description;
                let descSameFlag = true;
                arrItem.forEach((item: any, index: any) => {
                    if (arrParamCloneDeep[item].Description !== desc) {
                        descSameFlag = false;
                    }
                });

                if (descSameFlag) {
                    // 规则相同，备注相同的规则
                    repeatedRulesWithDesc.push(arrItem);
                } else {
                    // 规则相同，备注不同的规则
                    repeatedRulesNoDesc.push(arrItem);
                }
            });

            me.repeatedRulesWithDesc = repeatedRulesWithDesc;
            me.repeatedRulesNoDesc = repeatedRulesNoDesc;

            // 所有重复规则的索引
            allRepeatedRulesIndex = _.flatten(me.repeatedRulesWithDesc).concat(_.flatten(me.repeatedRulesNoDesc));

            // 所有非重复规则的索引
            let noneRepeatedRuleIndex: any[] = [];
            arrParamCloneDeep.forEach((param, paramIndex) => {
                let equalFlag = false;
                allRepeatedRulesIndex.forEach((rule: any, ruleIndex: any) => {
                    if (paramIndex === rule) {
                        equalFlag = true;
                    }
                })
                if (!equalFlag) {
                    noneRepeatedRuleIndex.push(paramIndex);
                }
            })
            me.noneRepeatedRuleIndex = noneRepeatedRuleIndex;

            let allRepeatedRules: any[] = [];
            allRepeatedRulesIndex.forEach((item: any, index: any) => {
                allRepeatedRules.push(arrParamCloneDeep[item]);
            });

            // 在重复的 Panel 中出现的规则生成UUID来区分
            allRepeatedRules.forEach((item: any, index: any) => {
                item.uuid = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            })

            me.allRepeatedRules = allRepeatedRules;
            me.originArrParam = _.cloneDeep(arrParam);
            me.repeatedRuleCheck.show = true;
            me.openRepeatedRuleDialog();

            return;
        }

        // var onOff = false;
        // _.forEach(cloneRulesData, function (item, index) {
        //     if (item.isError) {
        //         onOff = true;
        //     }
        // });

        // if (onOff) {
        //     me.inNotValid = true;
        //     return;
        // }

    }

    createSafe() {
        let me: any = this;
        let rules: any[] = [];
        me.isSameRuleIn = false;
        me.isSameRuleOut = false;
        me.isNameTrue = false;

        if (!me.createVpcList.length) {
            Message.error(me.$trans(`未找到可选虚拟私有网络`));
            return;
        }
        me.formatRule('in');
        me.formatRule('out');

        if (me.inNotValid || me.outNotValid) {
            Message.error(me.$trans(`有规则错误，请修正规则后再提交！`));
            return;
        }

        // let arrParamNew = me.arrParamInNew.concat(me.arrParamOutNew);
        // if (!me.regionSupportDeny) {
        //     _.forEach(arrParamNew, (item) => {
        //         delete item.Policy;
        //         delete item.Priority;
        //     });
        // }

        let arrParamNew = me.newInRulesData.concat(me.newOutRulesData);
        if (arrParamNew && arrParamNew.length) {
            _.forEach(arrParamNew, item => {
                let ruleItem: any = {
                    SecurityGroupId: me.groupId,
                    CidrBlock: _.trim(item.CidrBlock),
                    Policy: _.trim(item.Policy),
                    Priority: _.trim(item.Priority),
                    Direction: _.trim(item.Direction),
                    Protocol: _.trim(item.Protocol),
                    PortRangeFrom: _.trim(item.PortRangeFrom) || null,
                    PortRangeTo: _.trim(item.PortRangeTo) || null,
                    RuleTag: _.trim(item.RuleTag),
                    Description: _.trim(item.Description) || null
                };

                switch (item.Protocol) {
                    case "ssh":
                        ruleItem.Protocol = "tcp";
                        ruleItem.PortRangeFrom = 22;
                        ruleItem.PortRangeTo = 22;
                        break;
                    case "http":
                        ruleItem.Protocol = "tcp";
                        ruleItem.PortRangeFrom = 80;
                        ruleItem.PortRangeTo = 80;
                        break;
                    case "https":
                        ruleItem.Protocol = "tcp";
                        ruleItem.PortRangeFrom = 443;
                        ruleItem.PortRangeTo = 443;
                        break;
                    case "remote":
                        ruleItem.Protocol = "tcp";
                        ruleItem.PortRangeFrom = 3389;
                        ruleItem.PortRangeTo = 3389;
                        break;
                    case "openvpn":
                        ruleItem.Protocol = "udp";
                        ruleItem.PortRangeFrom = 1194;
                        ruleItem.PortRangeTo = 1194;
                        break;
                    case "ping":
                        ruleItem.Protocol = "icmp";
                        ruleItem.IcmpCode = 0;
                        ruleItem.IcmpType = 8;
                        break;
                    case "tcp":
                    case "udp":
                        ruleItem.Protocol = item.Protocol;
                        ruleItem.PortRangeFrom = Number(item.PortRangeFrom);
                        ruleItem.PortRangeTo = Number(item.PortRangeTo);
                        break;
                    case "icmp":
                        ruleItem.Protocol = "icmp";
                        ruleItem.IcmpCode = Number(
                            item.IcmpType == -1 ? "-1" : item.IcmpCode
                        );
                        ruleItem.IcmpType = Number(item.IcmpType);
                    default:
                        break;
                }

                rules.push(ruleItem);
            });
        }

        if (!rules.length) {
            return;
        }
        me.BatchCreateRules(rules);
    }

    BatchCreateRules(rules: any[]) {
        let me: any = this;

        if (!me.regionSupportDeny) {
            _.forEach(rules, item => {
                delete item.Policy;
                delete item.Priority;
            });
        }

        me.timer.timerPay && clearTimeout(me.timer.timerPay);
        me.timer.timerPay = setTimeout(() => {
            let urlParams = {
                "Region": me.region
            };
            let jsonParams = {
                VpcId: me.currentVpcs.value,
                SecurityGroupName: me.newGroupName == '' ? 'Ksc_SG' : me.newGroupName,
                SecurityGroupType: me.secGroupType,
                Params: rules
            };
            let optionParams = {
                isJSON: true
            };
            // apiRequest.BatchCopySecurityGroupEntry(
            this.request.BatchCopySecurityGroupEntry(
                [
                    urlParams,
                    jsonParams
                ],
                optionParams
            ).done(function (data: any) {
                let fails: any[] = [];
                _.forEach(data.SecurityGroupEntrySet, (item) => {
                    if (!item.IsSuccess) {
                        fails.push(item.Message);
                    }
                });
                if (fails.length) {
                    Message.error(fails.join());
                } else {
                    Message.success(me.$trans(`创建成功`));
                    localStorage.vpcId = me.currentVpcs.value;
                }

                setTimeout(function () {
                    me.$router.push({
                        name: me.isTrustVpc ? 'trustGroup' : 'group'
                    })
                }, 1000)

            }).always(() => {
                me.inNotValid = true;
                me.outNotValid = true;
                me.isLoading = false;
            });
        }, 400);
    }

    onCancel() {
        this.$router.push({
            name: this.isTrustVpc ? 'trustGroup' : 'group'
        })
    }

    isEqualRule(arr: any[]) {
        let index: any[] = [];  //所有重复的索引 [2,4,5,1,0,0]
        let newArr: any[] = []; //[3,2,2]  重复的后面的放进去
        let json: any = {} //{2:{index:0,value:2},3:{index:1,value:3}}
        let jsonFilter: any = {};
        let indexArr: any[] = []; //对index进行去重

        let jsonNew: any = {}  //{2:[0],3:[1,2],1:[3],2:[4,5]}
        let arrAll: any[] = [];
        _.forEach(arr, (item, index) => {
            if (!jsonNew[item]) {
                let arrh = [];
                arrh.push(index)
                jsonNew[item] = arrh;
            } else {
                jsonNew[item].push(index);
            }
        });

        for (let i in jsonNew) {
            if (jsonNew[i].length > 1) {
                arrAll.push(jsonNew[i])
            }
        }

        for (let i = 0; i < arr.length; i++) {
            if (!json[arr[i]]) {
                json[arr[i]] = {
                    "index": i,
                    "value": arr[i]
                }
            } else {
                index.push(i)
                newArr.push(arr[i])
            }
        }
        for (let i = 0; i < newArr.length; i++) {
            index.push(json[newArr[i]]["index"])
        }
        for (let i = 0; i < index.length; i++) {
            if (!jsonFilter[index[i]]) {
                jsonFilter[index[i]] = true
                indexArr.push(index[i])
            }
        }
        let obj = {
            arrAll: arrAll,
            indexArr: indexArr.sort()
        }
        return obj
    }

    DescribeSecurityGroups() {
        let me: any = this;
        return new Promise(resolve => {
            // apiRequest.DescribeSecurityGroups({
            this.request.DescribeSecurityGroups({
                Region: this.region,
                'SecurityGroupId.1': this.groupId
            }).done((data: any) => {
                let detail = _.get(data, 'SecurityGroupSet[0]', {});
                me.interfaceEpcCount = detail.InterfaceEpcCount || 0;

                resolve(detail)
            }).fail(() => {
                resolve({})
            })
        })
    }

    getNetworkInterfaceList(type: string, page: number, limit: number, searchField: string, searchValue: string) {
        let params: any = {
            Region: this.region,
            SgId: this.groupId,
            InstanceType: type,
            MaxResults: limit,
            NextToken: (page - 1) * limit + 1
        }

        if (searchValue) {
            params[searchField] = searchValue;
        }

        return new Promise(resolve => {
            // apiRequest.DescribeNetworkInterfaces(params).done((data: any) => {
            this.request.DescribeNetworkInterfaces(params).done((data: any) => {
                resolve(data);
            }).fail(() => {
                // resolve();
            })
        })
    }

}
